import React from "react";

import { Col, Row, Button, Container } from "@themesberg/react-bootstrap";

import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../redux/actions/auth";

export default () => {
  const dispatch = useDispatch();
  const {
    name,
    email,
    mobileNumber,
    username,
    sahakari: { name: sahakariName },
  } = useSelector((state) => state.user.userData);
  return (
    <main>
      <section className="bg-soft d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <h3 className="mb-4 d-flex justify-content-center">
                  My Profile
                </h3>
                <div className="d-flex mb-3 justify-content-between">
                  <h6 className="">Name:</h6>
                  <h6 className="">{name}</h6>
                </div>
                <div className="d-flex mb-3 justify-content-between">
                  <h6 className="">Username:</h6>
                  <h6 className="">{username}</h6>
                </div>
                <div className="d-flex mb-3 justify-content-between">
                  <h6 className="">Email:</h6>
                  <h6 className="">{email}</h6>
                </div>
                <div className="d-flex mb-3 justify-content-between">
                  <h6 className="">Mobile Number:</h6>
                  <h6 className="">{mobileNumber}</h6>
                </div>
                <div className="d-flex mb-3 justify-content-between">
                  <h6 className="">Sahakari:</h6>
                  <h6 className="">{sahakariName}</h6>
                </div>
                <Button
                  variant="danger"
                  type="submit"
                  className="w-100"
                  onClick={() => dispatch(logoutUser())}
                >
                  Log Out
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
